export default __webpack_public_path__ + "static/media/bullseye.3dfd4c5b.svg";